module.exports = __webpack_public_path__ + "media/icons/Download-Icon-3c32ad8a.svg";